export default "__VITE_ASSET__d238c3a6__"